// Validation
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const MAX_EMAIL_LENGTH = 80;

// 英字と数字2種類以上利用し、記号の入力は !"#$%&''()\-^@[;: を許可し、８文字以上72文字以内
export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!"#$%&'()\-\^@[\];:]{8,72}$/;
export const MAX_PASSWORD_LENGTH = 72;
export const MIN_PASSWORD_LENGTH = 8;

export const NAME_KANA_REGEX = /^[ァ-ンヴー]*$/;

export const PHONE_NUMBER_REGEX = /^[0-9]{10,11}$/;

// エラーメッセージ生成関数
const createRequiredMessage = (fieldName?: string) =>
  fieldName ? `${fieldName}を入力してください。` : "入力してください。";

const createMaxLengthMessage = (length: number) => `${length}文字以内で入力してください`;

const createMinLengthMessage = (length: number) => `${length}文字以上で入力してください`;

const createFormatInvalidMessage = (fieldName?: string) =>
  `※${fieldName ? `${fieldName}の` : ""}形式が正しくありません。`;

export const EMAIL_REQUIRED_MESSAGE = createRequiredMessage("メールアドレス");
export const EMAIL_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_EMAIL_LENGTH);
export const EMAIL_FORMAT_MESSAGE = createFormatInvalidMessage("メールアドレス");

export const PASSWORD_REQUIRED_MESSAGE = createRequiredMessage("パスワード");
export const PASSWORD_FORMAT_MESSAGE = createFormatInvalidMessage("パスワード");
export const PASSWORD_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_PASSWORD_LENGTH);
export const PASSWORD_MIN_LENGTH_MESSAGE = createMinLengthMessage(MIN_PASSWORD_LENGTH);

export const FAMILY_NAME_REQUIRED_MESSAGE = createRequiredMessage("姓");
export const FIRST_NAME_REQUIRED_MESSAGE = createRequiredMessage("名");
export const FAMILY_NAME_KANA_REQUIRED_MESSAGE = createRequiredMessage("姓（カナ）");
export const FIRST_NAME_KANA_REQUIRED_MESSAGE = createRequiredMessage("名（カナ）");
export const KANA_FORMAT_MESSAGE = "全角カタカナで入力してください。";

export const PASSWORD_CONFIRMATION_REQUIRED_MESSAGE = createRequiredMessage("パスワード（確認用）");
export const PASSWORD_MISMATCH_MESSAGE = "パスワードが一致しません。";

export const PHONE_NUMBER_REQUIRED_MESSAGE = createRequiredMessage("電話番号");
export const PHONE_NUMBER_FORMAT_MESSAGE = "電話番号は10桁または11桁の数字で入力してください。";
